import hoverSound from './sounds/62976__radian__chime-0001.mp3';
import clickSound from './sounds/tap-professional.mp3';
import transitionSound from './sounds/slide-network.mp3';
import backgroundMusic from './sounds/background-music.mp3';

export const TRANSITION_PAGE_OUT_SOUND = 'transitionPageOut';
export const TRANSITION_PAGE_IN_SOUND = 'transitionPageIn';
export const HOVER_BUTTON_SOUND = 'hoverButton';
export const CLICK_BUTTON_SOUND = 'clickButton';
export const BACKGROUND_MUSIC_SOUND = 'backgroundMusic';
export const BACKGROUND_CASINO_SOUND = 'casinoSounds';

export default function createSoundRegistry() {
  // Our soundsData is an object. The keys are the names of our sounds.
  return {
    // If no additional configuration is necessary, we can just pass a string as the path to our file.
    // If additional configuration is needed, an object can be passed with howler.js options.
    [TRANSITION_PAGE_OUT_SOUND]: {
      src: [transitionSound],
      volume: 0.5
    },
    [TRANSITION_PAGE_IN_SOUND]: {
      src: [transitionSound],
      volume: 0.5
    },
    [HOVER_BUTTON_SOUND]: {
      src: [hoverSound],
      volume: 0.04
    },
    [CLICK_BUTTON_SOUND]: clickSound,
    [BACKGROUND_MUSIC_SOUND]: {
      src: [backgroundMusic],
      sprite: {
        loop: [40, 44125]
      },
      loop: true,
      volume: 0,
      finalVolume: 1
    }
  };
}



// WEBPACK FOOTER //
// ./src/sounds.js